import _ from "lodash";

export const getPaymentStatusMessageLoading = (policy) =>
  _.get(policy, ["paymentStatusMessage", "loading"], false);
export const getPaymentStatusMessage = (policy) =>
  _.get(policy, ["paymentStatusMessage", "items"], null);

//Live Chat
export const getChatConfigurationLoading = (policy) =>
  _.get(policy, ["chatConfiguration", "loading"], false);
export const getChatConfigurationData = (policy) =>
  _.get(policy, ["chatConfiguration", "items"], null);
export const getChatConfigurationStatus = (policy) =>
  _.get(policy, ["chatConfiguration", "status"], false);
export const getChatConfigurationDataData = (item) =>
  _.get(item, ["Data"], null);
export const getChatConfigurationDataEnableAskEtiqa = (item) =>
  _.get(item, ["EnableAskEtiqa"], null);
export const getChatConfigurationDataEnableChatbot = (item) =>
  _.get(item, ["EnableChatbot"], null);
export const getChatConfigurationDataEnableLiveChat = (item) =>
  _.get(item, ["EnableLiveChat"], null);
export const getChatConfigurationDataEnableLiveChatHistory = (item) =>
  _.get(item, ["EnableLiveChatHistory"], null);
export const getChatConfigurationDataIsLiveChatActive = (item) =>
  _.get(item, ["IsLiveChatActive"], null);
export const getChatConfigurationDataIsLiveChatAllowScheduleCallback = (item) =>
  _.get(item, ["IsLiveChatAllowScheduleCallback"], null);
export const getChatConfigurationDataLiveChatPollingInterval = (item) =>
  _.get(item, ["LiveChatPollingInterval"], null);
export const getChatConfigurationDataLiveChatThreadId = (item) =>
  _.get(item, ["LiveChatThreadId"], null);
export const getChatConfigurationDataLiveChatWorkingEndTime = (item) =>
  _.get(item, ["LiveChatWorkingEndTime"], null);
export const getChatConfigurationDataLiveChatWorkingStartTime = (item) =>
  _.get(item, ["LiveChatWorkingStartTime"], null);

export const getCreateChatLoading = (policy) =>
  _.get(policy, ["createChat", "loading"], false);
export const getCreateChatData = (policy) =>
  _.get(policy, ["createChat", "items"], null);
export const getCreateChatStatus = (policy) =>
  _.get(policy, ["createChat", "status"], false);
export const getCreateChatDataData = (item) => _.get(item, ["Data"], null);
export const getCreateChatDataButtons = (item) =>
  _.get(item, ["Buttons"], null);
export const getCreateChatDataStatus = (item) => _.get(item, ["Status"], null);
export const getCreateChatDataClearHistory = (item) =>
  _.get(item, ["ClearHistory"], null);
export const getCreateChatDataThreadId = (item) =>
  _.get(item, ["ThreadId"], null);

export const getChatUpdateLoading = (policy) =>
  _.get(policy, ["chatUpdate", "loading"], false);
export const getChatUpdateData = (policy) =>
  _.get(policy, ["chatUpdate", "items"], null);
export const getChatUpdateStatus = (policy) =>
  _.get(policy, ["chatUpdate", "status"], false);
export const getChatUpdateDataData = (item) => _.get(item, ["Data"], null);
export const getChatUpdateDataAllowScheduleCallback = (item) =>
  _.get(item, ["AllowScheduleCallback"], null);
export const getChatUpdateDataChatUpdateMessageLists = (item) =>
  _.get(item, ["ChatUpdateMessageLists"], null);
export const getChatUpdateDataQueueEstTime = (item) =>
  _.get(item, ["QueueEstTime"], null);
export const getChatUpdateDataQueueNumber = (item) =>
  _.get(item, ["QueueNumber"], null);
export const getChatUpdateDataStatus = (item) => _.get(item, ["Status"], null);

export const getChatMessageLoading = (policy) =>
  _.get(policy, ["chatMessage", "loading"], false);
export const getChatMessageData = (policy) =>
  _.get(policy, ["chatMessage", "items"], null);
export const getChatMessageStatus = (policy) =>
  _.get(policy, ["chatMessage", "status"], false);
export const getChatMessageDataData = (item) => _.get(item, ["Data"], null);
export const getChatMessageDataGetChatMessageLists = (item) =>
  _.get(item, ["GetChatMessageLists"], null);
export const getChatMessageDataStatus = (item) => _.get(item, ["Status"], null);

export const getCreateMessageLoading = (policy) =>
  _.get(policy, ["createMessage", "loading"], false);
export const getCreateMessageData = (policy) =>
  _.get(policy, ["createMessage", "items"], null);
export const getCreateMessageStatus = (policy) =>
  _.get(policy, ["createMessage", "status"], false);
export const getCreateMessageDataData = (item) => _.get(item, ["Data"], null);
export const getCreateMessageDataButtons = (item) =>
  _.get(item, ["Buttons"], null);
export const getCreateMessageDataChatId = (item) =>
  _.get(item, ["ChatId"], null);
export const getCreateMessageDataErrorMessage = (item) =>
  _.get(item, ["ErrorMessage"], null);
export const getCreateMessageDataStatus = (item) =>
  _.get(item, ["Status"], null);

export const getTwilioQuitQueueLoading = (policy) =>
  _.get(policy, ["quitTwilioQueue", "loading"], false);
export const getTwilioQuitQueueData = (policy) =>
  _.get(policy, ["quitTwilioQueue", "items"], null);
export const getTwilioQuitQueueStatus = (policy) =>
  _.get(policy, ["quitTwilioQueue", "status"], false);
export const getTwilioQuitQueueDataData = (item) => _.get(item, ["Data"], null);

export const getScheduleCallBackLoading = (policy) =>
  _.get(policy, ["scheduleCallBack", "loading"], false);
export const getScheduleCallBackData = (policy) =>
  _.get(policy, ["scheduleCallBack", "items"], null);
export const getScheduleCallBackStatus = (policy) =>
  _.get(policy, ["scheduleCallBack", "status"], false);
export const getScheduleCallBackDataData = (item) =>
  _.get(item, ["Data"], null);
export const getScheduleCallBackDataStatus = (item) =>
  _.get(item, ["Status"], null);
export const getScheduleCallBackDataStartAfter = (item) =>
  _.get(item, ["StartAfter"], null);
export const getScheduleCallBackDataDisabledDateLists = (item) =>
  _.get(item, ["DisabledDateLists"], null);

export const getDisabledTimeListsLoading = (policy) =>
  _.get(policy, ["disableTimeList", "loading"], false);
export const getDisabledTimeListsData = (policy) =>
  _.get(policy, ["disableTimeList", "items"], null);
export const getDisabledTimeListsStatus = (policy) =>
  _.get(policy, ["disableTimeList", "status"], false);
export const getDisabledTimeListsDataData = (item) =>
  _.get(item, ["Data"], null);
export const getDisabledTimeListsDataIntervalTime = (item) =>
  _.get(item, ["IntervalTime"], null);
export const getDisabledTimeListsDataIsFull = (item) =>
  _.get(item, ["IsFull"], null);
export const getDisabledTimeListsDataScheduleCallbackEnd = (item) =>
  _.get(item, ["ScheduleCallbackEnd"], null);
export const getDisabledTimeListsDataScheduleCallbackStart = (item) =>
  _.get(item, ["ScheduleCallbackStart"], null);
export const getDisabledTimeListsDataStatus = (item) =>
  _.get(item, ["Status"], null);
export const getDisabledTimeListsDisableTimeLists = (item) =>
  _.get(item, ["DisableTimeLists"], null);

export const createAppointmentLoading = (policy) =>
  _.get(policy, ["createAppointment", "loading"], false);
export const createAppointmentData = (policy) =>
  _.get(policy, ["createAppointment", "items"], null);
export const createAppointmentStatus = (policy) =>
  _.get(policy, ["createAppointment", "status"], false);
export const createAppointmentDataData = (item) => _.get(item, ["Data"], null);
export const createAppointmentDataStatus = (item) =>
  _.get(item, ["Status"], null);

//Get Profile Info
export const getProfileLoading = (policy) =>
  _.get(policy, ["profile", "loading"], false);
export const getProfile = (policy) => _.get(policy, ["profile", "items"], null);

//User Info
export const getUserName = (item) => _.get(item, ["name"], "");
export const getUserNric = (item) => _.get(item, ["nric"], "");
export const getDateOfBirth = (item) => _.get(item, ["dob"], "");
export const getUserGender = (item) => _.get(item, ["gender"], "");
export const getMartialStatus = (item) => _.get(item, ["marital_status"], "");
export const getUserEmail = (item) => _.get(item, ["email"], "");
export const getUserMobile = (item) => _.get(item, ["mobile"], "");
export const getUserUnit = (item) => _.get(item, ["unit"], "");
export const getUserBlock = (item) => _.get(item, ["block"], "");
export const getUserStreet = (item) => _.get(item, ["street"], "");
export const getUserPostal = (item) => _.get(item, ["postal"], "");
export const getUserResidentialAddress = (item) =>
  _.get(item, ["residential_address"], "");
export const getUserShowAddressNote = (item) =>
  _.get(item, ["show_residential_address_note"], "");
export const getUserID = (item) => _.get(item, ["user_id"], "");
export const getLoginID = (item) => _.get(item, ["login_id"], "");
export const getLoginName = (item) => _.get(item, ["loginName"], "");

//getChatReplyStatus
export const getChatReplyStatusLoading = (policy) =>
  _.get(policy, ["getChatReplyStatus", "loading"], false);
export const getChatReplyStatusData = (policy) =>
  _.get(policy, ["getChatReplyStatus", "items"], null);
export const getChatReplyStatusStatus = (policy) =>
  _.get(policy, ["getChatReplyStatus", "status"], false);

//connect live chat
export const connectLiveChatLoading = (policy) =>
  _.get(policy, ["connectLiveChat", "loading"], false);
export const connectLiveChatData = (policy) =>
  _.get(policy, ["connectLiveChat", "items"], null);
export const connectLiveChatStatus = (policy) =>
  _.get(policy, ["connectLiveChat", "status"], false);

//get insider client info
export const getInsiderClientInfoReqLoading = (policy) =>
  _.get(policy, ["getInsiderClientInfo", "loading"], false);
export const getInsiderClientInfoReqStatus = (policy) =>
  _.get(policy, ["getInsiderClientInfo", "status"], false);
export const getInsiderClientInfoReqData = (policy) =>
  _.get(policy, ["getInsiderClientInfo", "items"], null);

//singtelPartnershipLeads
export const singtelPartnershipLeadsReqLoading = (policy) =>
  _.get(policy, ["singtelPartnershipLeads", "loading"], false);
export const singtelPartnershipLeadsReqStatus = (policy) =>
  _.get(policy, ["singtelPartnershipLeads", "status"], false);
export const singtelPartnershipLeadsReqData = (policy) =>
  _.get(policy, ["singtelPartnershipLeads", "items"], null);
